/**
 * Format a date string to a readable format based on locale.
 * @param dateString - ISO format date string (e.g., "2026-03-11T12:01:25.171000")
 * @param locale - Locale code (e.g., "tr-TR", "en-US")
 * @returns Formatted date string with time (e.g., "11-03-2026 12:01" for tr-TR, "03-11-2026 12:01" for en-US)
 */
export const formatDateReadable = (
  dateString: string | undefined | null,
  locale: string = 'tr-TR'
): string => {
  if (!dateString) return '';

  try {
    const date = new Date(dateString);

    // Check if date is valid
    if (isNaN(date.getTime())) return dateString;

    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();

    // Pad with zeros
    const padZero = (n: number) => String(n).padStart(2, '0');
    const dayStr = padZero(day);
    const monthStr = padZero(month);
    const hoursStr = padZero(hours);
    const minutesStr = padZero(minutes);
    const timeStr = `${hoursStr}:${minutesStr}`;

    // Format based on locale
    if (locale.startsWith('en')) {
      // English format: MM-DD-YYYY HH:MM
      return `${monthStr}-${dayStr}-${year} ${timeStr}`;
    }

    // Turkish and most European locales: DD-MM-YYYY HH:MM
    return `${dayStr}-${monthStr}-${year} ${timeStr}`;
  } catch (e) {
    return dateString || '';
  }
};
